// SEO içerik sayfaları için tek kaynaklı veri katmanı.
// /online-dershane ve /online-deneme-sinavi sayfaları buradan beslenir.

export interface SeoFaq {
  question: string;
  answer: string;
}

export interface SeoBenefit {
  icon: string;
  title: string;
  text: string;
}

export interface SeoStep {
  title: string;
  text: string;
}

export interface SeoBlock {
  heading: string;
  text: string;
}

export interface SeoStat {
  value: string;
  label: string;
}

export interface SeoRelated {
  label: string;
  href: string;
}

export interface SeoPageData {
  slug: string;
  crumb: string;
  metaTitle: string;
  metaDescription: string;
  eyebrow: string;
  title: string;
  subtitle: string;
  stats: SeoStat[];
  benefits: SeoBenefit[];
  steps: SeoStep[];
  blocks: SeoBlock[];
  faq: SeoFaq[];
  ctaTitle: string;
  ctaText: string;
  related: SeoRelated[];
}

export const seoPages: SeoPageData[] = [
  {
    slug: "online-egitim",
    crumb: "Online Eğitim",
    metaTitle: "Online Eğitim Nedir? | DersDinle Online Eğitim Platformu",
    metaDescription:
      "Online eğitim nedir, nasıl çalışır? DersDinle ile video dersler, canlı dersler, soru bankası ve deneme sınavları tek platformda. LGS, TYT, AYT ve KPSS'ye online hazırlanın.",
    eyebrow: "Online Eğitim",
    title: "Online eğitim ile sınırsız öğrenme",
    subtitle:
      "Okul öncesinden üniversite ve kamu sınavlarına kadar; video ders, canlı ders, soru bankası ve deneme sınavını tek çatı altında toplayan dijital eğitim platformu.",
    stats: [
      { value: "Adım adım", label: "konu çalışması" },
      { value: "Canlı", label: "dersler ve kayıtlar" },
      { value: "Açıklamalı", label: "alıştırmalar" },
      { value: "4", label: "rol · öğrenci, veli, öğretmen, yönetici" },
    ],
    benefits: [
      {
        icon: "ri-time-line",
        title: "Zaman ve mekân bağımsız",
        text: "Dilediğin yerden, kendi hızında çalış; ders programına bağlı kalmadan ilerle.",
      },
      {
        icon: "ri-route-line",
        title: "Kişisel öğrenme rotası",
        text: "Seviyene ve hedef sınavına göre her gün ne çalışacağını bil; planlı ilerle.",
      },
      {
        icon: "ri-live-line",
        title: "Canlı ders ve kayıt",
        text: "Öğretmeninle eş zamanlı çalış, kaçırdığın dersi kaydından sonra izle.",
      },
      {
        icon: "ri-list-check-3",
        title: "Soru bankası ve çözüm",
        text: "Konuya göre filtrelenebilir sorular, yazılı ve video çözüm desteğiyle.",
      },
      {
        icon: "ri-file-text-line",
        title: "Deneme ve analiz",
        text: "Gerçek sınav formatında denemeler, ders bazlı net ve gelişim takibi.",
      },
      {
        icon: "ri-robot-2-line",
        title: "AI eğitim koçu",
        text: "Eksik konularını tespit eden, sana özel öneriler sunan yapay zekâ desteği.",
      },
    ],
    steps: [
      { title: "Kayıt ol", text: "Birkaç dakikada ücretsiz hesabını oluştur." },
      { title: "Seviyeni seç", text: "Sınıfını veya hedef sınavını belirle." },
      { title: "Rotanı kur", text: "Sana göre planlanan günlük çalışma akışını gör." },
      { title: "Çalış", text: "İzle, çöz, soru sor; öğrenme döngüsünü sürdür." },
      { title: "Analiz et", text: "Sonuçlarını gör, eksiklerini planlı kapat." },
    ],
    blocks: [
      {
        heading: "Online eğitim nedir?",
        text: "Online eğitim, yüz yüze eğitimin sunduğu eğitim hizmetlerini dijital ortama taşıyan bir platformdur. Öğrenci; video ders izleyebilir, canlı derse katılabilir, soru çözebilir ve deneme sınavına girebilir. Tüm bu süreç internet üzerinden, dilediği zaman ve mekânda gerçekleşir. Böylece hem zaman tasarrufu sağlanır hem de öğrenme kişisel bir rotaya dönüşür.",
      },
      {
        heading: "Neden online eğitim tercih edilmeli?",
        text: "Online eğitim; ulaşım maliyetini ortadan kaldırır, ders saatlerini esnek hale getirir ve her öğrencinin kendi hızında ilerlemesine olanak tanır. Kaçırılan dersin kaydına erişim, anlık soru çözümü ve düzenli gelişim analizi gibi avantajlar, dijital eğitimi geleneksel modelin güçlü bir tamamlayıcısı yapar.",
      },
      {
        heading: "DersDinle ile online eğitim",
        text: "DersDinle, öğrencinin 'ders izle → canlı derse katıl → soru çöz → denemeye gir → sonucu analiz et → eksik konularını kapat' döngüsünü tek platformda tamamlamasını sağlar. Yapay zekâ destekli koçluk ve veli takibiyle öğrenme süreci hem öğrenci hem aile için şeffaf ve planlı ilerler.",
      },
    ],
    faq: [
      {
        question: "Online eğitim nedir?",
        answer:
          "Online eğitim, yüz yüze eğitimin eğitim hizmetlerini internet üzerinden sunan dijital bir platformdur. Video dersler, canlı dersler, soru bankası ve deneme sınavları tek çatı altında toplanır; öğrenci dilediği yerden ve zamanda çalışabilir.",
      },
      {
        question: "Online eğitimde canlı dersler nasıl işliyor?",
        answer:
          "Canlı derslerde öğrenci, öğretmeniyle eş zamanlı olarak çalışır. Ders sırasında sohbet ve dijital tahta ile etkileşime girebilir, aklına takılan soruyu anında sorabilir. Ders programı haftalık takvimde görünür ve kaçırılan dersin kaydı sonradan izlenebilir.",
      },
      {
        question: "Kaçırdığım dersleri sonradan izleyebilir miyim?",
        answer:
          "Evet. Canlı derse yetişemediğinizde veya tekrar etmek istediğinizde ders kayıtlarına erişebilir, kaçırdığınız konuyu kendi hızınızda tamamlayabilirsiniz. Video derslerde kaldığınız yerden devam edebilirsiniz.",
      },
      {
        question: "Hangi sınıf ve sınavlara yönelik içerik var?",
        answer:
          "Okul öncesinden 12. sınıfa kadar okul müfredatı, ayrıca LGS, TYT, AYT, YDT, KPSS, DGS, ALES, YDS ve YÖKDİL gibi sınavlara hazırlık içerikleri bulunur. Başlangıç içerikleri seçilen sınıf ve hedefe göre sunulur; kapsam kademeli olarak genişletilir. Okul öncesinde oyun ve keşif etkinlikleri yer alır.",
      },
      {
        question: "Online eğitim ücretli mi? Ücretsiz deneme var mı?",
        answer:
          "Platform üyelik paketleri ücretlidir; ancak yeni kullanıcılar için ücretsiz deneme süresi sunulur. Paketler ve güncel fiyatlar için paketler sayfasını inceleyebilirsiniz.",
      },
      {
        question: "Veli olarak çocuğumun ilerlemesini nasıl takip ederim?",
        answer:
          "Veli paneli üzerinden çocuğunuzun dersleri, çalışma süresi, canlı ders katılımı, deneme sonuçları, netleri, ödevleri ve devamsızlığı tek yerden takip edilebilir. Haftalık gelişim raporu ve yapay zekâ analizi de veliye sunulur.",
      },
    ],
    ctaTitle: "Online eğitimye bugün başla.",
    ctaText: "Seviyeni seç, kişisel rotanı kur; her gün ne çalışacağını bil.",
    related: [
      { label: "Online Deneme Sınavı", href: "/online-deneme-sinavi" },
      { label: "Sınavlara Hazırlık", href: "/sinavlar" },
      { label: "Eğitimler", href: "/egitimler" },
      { label: "Paketler", href: "/paketler" },
    ],
  },
  {
    slug: "online-deneme-sinavi",
    crumb: "Online Deneme Sınavı",
    metaTitle: "Online Deneme Sınavı: Gerçek Sınav Deneyimi | DersDinle",
    metaDescription:
      "Online deneme sınavı ile gerçek sınav formatında kendini test et. Ders bazlı net analizi, süre yönetimi ve gelişim takibi. LGS, TYT, AYT, KPSS denemeleri DersDinle'de.",
    eyebrow: "Online Deneme Sınavı",
    title: "Gerçek sınav deneyimini online yaşa",
    subtitle:
      "Gerçek sınav formatına birebir uygun denemeler, süre yönetimi ve ders bazlı net analiziyle seviyeni ölç, gelişimini izle.",
    stats: [
      { value: "Gerçek", label: "sınav formatı ve süre" },
      { value: "Ders bazlı", label: "net ve hata analizi" },
      { value: "Planlı", label: "deneme ve tekrar" },
      { value: "Anlık", label: "sonuç ve rapor" },
    ],
    benefits: [
      {
        icon: "ri-file-text-line",
        title: "Sınav formatına uyum",
        text: "LGS, TYT, AYT, KPSS ve diğer sınavlarla aynı soru dağılımı ve sürede denemeler.",
      },
      {
        icon: "ri-timer-line",
        title: "Süre yönetimi",
        text: "Gerçek sınav süresiyle prova yaparak tempoya ve zaman yönetimine alış.",
      },
      {
        icon: "ri-bar-chart-line",
        title: "Net analizi",
        text: "Doğru, yanlış, boş ve net sonuçlarını ders bazında ayrıntılı gör.",
      },
      {
        icon: "ri-alert-line",
        title: "Eksik konu tespiti",
        text: "Yanlışların otomatik analiz edilir, eksik konuların belirlenir.",
      },
      {
        icon: "ri-line-chart-line",
        title: "Gelişim takibi",
        text: "Denemeler arası net değişimini grafiklerle izle.",
      },
      {
        icon: "ri-close-circle-line",
        title: "Yanlış tekrarı",
        text: "Yanlış yaptığın sorular listelenir, tekrar için planlanır.",
      },
    ],
    steps: [
      { title: "Denemeyi seç", text: "Hedef sınavına uygun denemeyi bul." },
      { title: "Süreye karşı çöz", text: "Gerçek sınav süresiyle kendini dene." },
      { title: "Sonucunu gör", text: "Anında doğru, yanlış, boş ve net sonucunu incele." },
      { title: "Analiz et", text: "Ders bazlı eksiklerini belirle, rotana yansıt." },
    ],
    blocks: [
      {
        heading: "Online deneme sınavı nedir?",
        text: "Online deneme sınavı, gerçek sınav koşullarını dijital ortamda birebir taklit eden bir değerlendirme aracıdır. Öğrenci, sınavla aynı soru dağılımı ve süre içinde soruları çözer; sınav bittikten hemen sonra doğru, yanlış, boş ve net sonuçlarını görür.",
      },
      {
        heading: "Deneme sonuçları nasıl analiz edilir?",
        text: "Her deneme sonrası sonuç, ders bazında ayrıntılı olarak raporlanır. Hangi dersten kaç net çıkardığınız, hangi konularda hata yaptığınız görülür. Eksik konular belirlenir ve bir sonraki çalışma planınıza otomatik yansıtılır.",
      },
      {
        heading: "Deneme çözmenin faydaları",
        text: "Düzenli deneme, yalnızca bilgiyi ölçmekle kalmaz; süre yönetimi, soru önceliklendirme ve sınav stresiyle başa çıkma becerisini de geliştirir. Gerçek sınavdan önce düzenli deneme pratiği yapan adaylar, tempoyu ve stratejiyi daha iyi oturtur.",
      },
    ],
    faq: [
      {
        question: "Online deneme sınavı nedir?",
        answer:
          "Online deneme sınavı, gerçek sınav koşullarını dijital ortamda taklit eden bir değerlendirme aracıdır. Öğrenci, sınavla aynı soru dağılımı ve süre içinde soruları çözer, sınav bitince sonuçlarını anında görür.",
      },
      {
        question: "Deneme sonuçları nasıl analiz ediliyor?",
        answer:
          "Sonuçlar ders bazında ayrıntılı raporlanır; doğru, yanlış, boş ve net sayıları gösterilir. Hata yapılan konular belirlenir ve eksik konular bir sonraki çalışma planına otomatik yansıtılır.",
      },
      {
        question: "Hangi sınav formatlarında deneme var?",
        answer:
          "LGS, TYT, AYT, YDT, KPSS, DGS, ALES, YDS ve YÖKDİL gibi sınav formatlarına uygun denemeler bulunur. Her deneme, ilgili sınavın soru dağılımı ve süresine göre hazırlanır.",
      },
      {
        question: "Deneme sınavlarına kaç kez girebilirim?",
        answer:
          "Denemeler düzenli aralıklarla planlanır ve tekrarlanabilir. Gelişim takibi sayesinde denemeler arası net değişiminiz grafiklerle izlenir; düzenli pratik için sınırsız tekrar yapılabilir.",
      },
      {
        question: "Yanlış yaptığım sorulara nasıl ulaşırım?",
        answer:
          "Yanlış yaptığınız sorular 'Yanlış Sorularım' bölümünde listelenir ve tekrar için planlanır. Böylece aynı hataları tekrarlamadan eksiklerinizi kapatabilirsiniz.",
      },
      {
        question: "Süre yönetimi nasıl çalışır?",
        answer:
          "Deneme, gerçek sınavın süresiyle işler; geri sayım sayacı süreyi takip eder. Böylece gerçek sınavdaki zaman baskısına önceden alışır, hangi soru türüne öncelik vereceğinizi öğrenirsiniz.",
      },
    ],
    ctaTitle: "İlk denemeni çöz, seviyeni öğren.",
    ctaText: "Gerçek sınav formatında deneme çöz, netini ve gelişimini izle.",
    related: [
      { label: "Online Eğitim", href: "/online-egitim" },
      { label: "Deneme Sınavları", href: "/deneme-sinavlari" },
      { label: "Sınavlara Hazırlık", href: "/sinavlar" },
      { label: "Soru Bankası", href: "/soru-bankasi" },
    ],
  },
];